// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1QCWI","boxTitle":"Qualiphy_boxTitle__1JLgP","box":"Qualiphy_box__3IfTn","toggleWrap":"Qualiphy_toggleWrap__Y0Us6"};